import { api_url } from "../configiration/config";
import { axiosClone } from "./../axiosClone";

// get blog sections
export async function getBlogSections(){
    return await axiosClone.get(`${api_url}/blog-sections`);
}
// get section details
export async function getSectionDetails(sectionSlug){
    return await axiosClone.get(`${api_url}/blogs-section/${sectionSlug}`);
}
// get blog details
export async function getBlogDetails(blogSlug){
    return await axiosClone.get(`${api_url}/blogs/${blogSlug}`);
}
// get popular blogs
export async function getPopularBlogs(slug){
    return await axiosClone.get(`${api_url}/blogs/popular?per_page=4&slug=${slug}`);
}
// get blogs by section
export async function getBlogsBySection(section){
    return await axiosClone.get(`${api_url}/blogs?section=${section}`);
}